import { FlipperKey } from '~/store/flippers/types'
import { ActionTypes, Dispatch } from '~/store/types'
import { FLIPPER_RESPONSE_MAP } from './const'
import { EARN_ACTIONS, StateFlipperKey } from './types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setFlippers = (keys: FlipperKey[], flipperResponse: any) => (
  dispatch: Dispatch<ActionTypes>
) => {
  const flippers = new Map<StateFlipperKey, boolean>()

  if (keys && flipperResponse) {
    keys.forEach(key => {
      const prop = FLIPPER_RESPONSE_MAP[key]
      const enabled = flipperResponse[key] as boolean

      if (prop && enabled !== undefined) {
        flippers.set(prop, enabled)
      }
    })

    if (flippers.size > 0) {
      dispatch({
        type: EARN_ACTIONS.SET_FLIPPERS,
        flippers,
      })
    }
  }
}
